export default __webpack_public_path__ + "static/media/Sienna_9781846161933.311096b2.jpg";